const hexToRgb = (hex: string) => {
  // Convert the hex code to RGB values
  if (hex) {
    const r = parseInt(hex?.substring(1, 3), 16);
    const g = parseInt(hex?.substring(3, 5), 16);
    const b = parseInt(hex?.substring(5, 7), 16);

    return { r, g, b };
  } else {
    return { r: 0, g: 0, b: 0 };
  }
};
export default hexToRgb;
